<template>
    <div id="full-wrapper" style="width: 100vw; background-color: #084D80;">
        <div id="home-page-wrapper">
            <img class="home-left" src="https://api.mpengs.com/image/mp_home.jpg">
            <img class="home-right" src="https://api.mpengs.com/image/mp_home_right.jpg">
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomePage',
}
</script>

<style scoped>
html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden; /* Prevents horizontal scrolling */
    overflow-y: auto; /* Allows vertical scrolling */
}

/* Hides scrollbars globally */
html::-webkit-scrollbar, body::-webkit-scrollbar {
    display: none;
}
#full-wrapper::-webkit-scrollbar, body::-webkit-scrollbar {
    display: none;
}
#full-wrapper {
    height: calc(100vh - 70px);
    overflow: hidden;
}

#home-page-wrapper {
    width: 90vw;
    max-width: 1600px;
    height: calc(100vh - 140px);
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

.home-left, .home-right {
    width: 50%;
    height: 100%;
    color: black;
    font-weight: 500;
    font-size: 2rem;
    letter-spacing: 0.05rem;
}

.home-right {
    background-color: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 1025px) {
    #home-page-wrapper {
        display: block;
        height: auto; /* Changed to auto to accommodate content */
    }
    #full-wrapper {
        height: auto; /* Adjusted to auto to contain all content */
        width: 100vw;
        max-width: 100vw;
        overflow: hidden;
    }
    .home-left, .home-right {
        width: 90vw;
        height: auto; /* Changed to auto to ensure images resize correctly */
        margin-bottom: 5vw;
    }
}
</style>
